import { createFileRoute, redirect } from "@tanstack/react-router";
import { sessionActions } from "@/features/auth/session";
import { WorkspaceGuard } from "@/features/auth/WorkspaceGuard";

export const Route = createFileRoute("/app/operator")({
  beforeLoad: async () => {
    const s = await sessionActions.whenSettled();
    if (!s.persona.isOperator) throw redirect({ to: "/app/forbidden" });
  },
  component: () => <WorkspaceGuard allow={(p) => p.isOperator} />,
});
